module.exports = __webpack_public_path__ + "webdesign.jpg?167cd8d7fe2d54d2eca1a307f1682fce";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/webdesign.jpg
// module id = 24
// module chunks = 0